import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { supabase } from '../lib/supabase';

interface ContentContextType {
  t: (key: string) => string;
  loading: boolean;
}

const ContentContext = createContext<ContentContextType>({
  t: (key) => key,
  loading: true,
});

export function ContentProvider({ children }: { children: ReactNode }) {
  const [content, setContent] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadContent() {
      const { data, error } = await supabase
        .from('website_content')
        .select('key, value');

      if (!error && data) {
        const map: Record<string, string> = {};
        data.forEach(({ key, value }) => { map[key] = value; });
        setContent(map);
      }
      setLoading(false);
    }
    loadContent();
  }, []);

  const t = (key: string): string => content[key] ?? key;

  return (
    <ContentContext.Provider value={{ t, loading }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}
